import React from 'react';

const SHENSHA_COLORS = {
  "天乙贵人": "#D4AF37",
  "文昌贵人": "#6B8E23",
  "华盖": "#4A4A8A",
  "桃花": "#C71585",
  "驿马": "#228B22",
  "禄神": "#B8860B",
  "羊刃": "#8B0000",
  "将星": "#4169E1",
  "天德贵人": "#DAA520",
  "月德贵人": "#9370DB",
  "空亡": "#696969",
};

export default function NayinShenshaSection({ data, narrative }) {
  if (!data || !data.key_shensha) return null;

  const nayin = data.year_nayin;
  const chain = data.chain;
  const shensha = data.key_shensha;

  return (
    <div>
      {/* 纳音生克链 */}
      <p style={{ fontSize: 14, lineHeight: 1.9, color: '#333', marginBottom: 24 }}>
        {chain}
      </p>

      {/* 神煞卡片 */}
      {Object.keys(shensha).length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 10 }}>
            命带神煞
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {Object.entries(shensha).map(([name, info]) => (
              <div key={name} style={{
                padding: '6px 12px',
                background: `${SHENSHA_COLORS[name] || '#888'}10`,
                border: `1px solid ${SHENSHA_COLORS[name] || '#888'}33`,
                borderRadius: 8,
                fontSize: 12,
              }}>
                <span style={{
                  color: SHENSHA_COLORS[name] || '#888',
                  fontWeight: 600,
                }}>
                  {name}
                </span>
                <span style={{ color: '#888', marginLeft: 6 }}>
                  ({(info.found || []).join('·')})
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* AI 叙事 */}
      {narrative && (
        <div style={{
          fontSize: 14,
          lineHeight: 1.9,
          color: '#444',
        }}>
          {narrative.split('\n').filter(Boolean).map((para, i) => (
            <p key={i} style={{ marginBottom: 10 }}>{para}</p>
          ))}
        </div>
      )}
    </div>
  );
}
